export default "__VITE_ASSET__BJETur5q__"